import { GatsbyImage, StaticImage } from "gatsby-plugin-image";
import React from "react";
import { FlexBox } from "../FlexBox";
import { PatstorePerson } from "@types";
import { useFindImages } from "@provider";

type ContactPersonProps = {
  person: PatstorePerson;
};

const ContactPerson: React.FC<ContactPersonProps> = ({ person }) => {
  const { findImage } = useFindImages();

  return (
    <FlexBox align="center" hasFullWidth styles={{ margin: "6px 0" }}>
      <div css={{ marginRight: "1em" }}>
        {person.image ? (
          <GatsbyImage
            alt={person.title || ""}
            image={findImage(person.image)}
            objectFit="cover"
            objectPosition="top"
            style={{width: "60px", height: "60px", borderRadius: "4px"}}
          />
        ) : (
          <StaticImage
            alt={person.title || ""}
            src="./images/placeholder_m.png"
            height={200}
            width={200}
            objectFit="cover"
            objectPosition="top"
            style={{width: "60px", height: "60px", borderRadius: "4px"}}
          />
        )}
      </div>

      <div>
        <h4>{person.title || ""}</h4>
        {person.email && (
          <a href={`mailto:${person.email}`}>E-Mail schreiben</a>
        )}
      </div>
    </FlexBox>
  );
};

export default ContactPerson;
